import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { StoryHook } from '../components/StoryHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsItFor } from '../components/WhoIsItFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    setTimeout(() => {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 300);
  }, []);
  return <main className="min-h-screen bg-stone-950 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-161">
      <HeroSection data-id="element-162" />
      <StoryHook data-id="element-163" />
      <ProblemSection data-id="element-164" />
      <FailedSolutions data-id="element-165" />
      <MechanismSection data-id="element-166" />
      <WhatYouGet data-id="element-167" />
      <WhoIsItFor data-id="element-168" />
      <HowItWorks data-id="element-169" />
      <ProofSection data-id="element-170" />
      <FAQSection data-id="element-171" />
      <PricingSection data-id="element-172" />
      <Footer data-id="element-173" />
    </main>;
}